import { render, staticRenderFns } from "./CategoriaPergunta.vue?vue&type=template&id=191a231a&"
import script from "./CategoriaPergunta.vue?vue&type=script&lang=js&"
export * from "./CategoriaPergunta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports